import {
    CLEAR_SELECTED_CONVERSATION,
    CLOSE_FORWARD_DIALOG,
    DELETE_CHAT_MESSAGE,
    DESTROY_CHAT,
    EDIT_CHAT_MESSAGE,
    FORWARD_CONVERSATION_FAILED,
    FORWARD_CONVERSATION_REQUESTED,
    FORWARD_CONVERSATION_SUCCEEDED,
    HANDLE_NOT_SENT_MESSAGE,
    INIT_CHAT_FAILED,
    INIT_CHAT_REQUESTED,
    INIT_CHAT_SUCCEEDED,
    INSERT_CHAT_MESSAGE,
    INSERT_CONVERSATION,
    LOAD_OLDER_MESSAGES_FAILED,
    LOAD_OLDER_MESSAGES_REQUESTED,
    LOAD_OLDER_MESSAGES_SUCCEEDED,
    OPEN_FORWARD_DIALOG,
    REMOVE_CONVERSATION,
    SELECT_CONVERSATION_FAILED,
    SELECT_CONVERSATION_REQUESTED,
    SELECT_CONVERSATION_SUCCEEDED,
    SET_CONVERSATIONS_LIST, SET_MESSAGE_SEEN,
    UPDATE_CONVERSATION,
    UPDATE_SELECTED_CONVERSATION, USER_TYPING_START, USER_TYPING_STOP,
} from './actionTypes';

const forwardDialogInitialState = {
    isOpen: false,
    forwardInProgress: false,
};

const initialState = {
    activeTypingConvIds: [],
    conversationsList: [],
    conversation: getConversationInitialState(),
    synced: false,
    initializing: false,
    forwardDialog: forwardDialogInitialState,
};

function getConversationInitialState() {
    return {
        id: null,
        userFirstName: null,
        userLastName: null,
        userId: null,
        userPlatformId: null,
        thumb: null,
        platform: null,
        messages: [],
        messagesTotalNumber: 0,
        loadingOlderMessages: false,
        loading: false,
    };
}

export default function (state = initialState, action) {
    switch (action.type) {
        case INIT_CHAT_REQUESTED:
            return Object.assign({}, state, {initializing: true});

        case INIT_CHAT_SUCCEEDED:
            return Object.assign({}, state, {initializing: false, synced: true});

        case INIT_CHAT_FAILED:
            return Object.assign({}, state, initialState);

        case SET_CONVERSATIONS_LIST:
            return Object.assign({}, state, {
                conversationsList: action.payload.conversationsList,
            });

        case REMOVE_CONVERSATION:
            return Object.assign({}, state, {
                conversationsList: state.conversationsList.filter(conversation => conversation.id !== action.payload.id),
                conversation: state.conversation.id !== action.payload.id ? state.conversation : getConversationInitialState(),
            });

        case UPDATE_CONVERSATION: {
            return Object.assign({}, state, {
                conversationsList: state.conversationsList.map((conversation) => {
                    if (conversation.id !== action.payload.id) {
                        return conversation;
                    }
                    return Object.assign({}, conversation, action.payload.update);
                }),
            });
        }

        case INSERT_CONVERSATION: {
            const index = state.conversationsList.findIndex(curConversation => action.payload.conversation
                && curConversation.id === action.payload.conversation.id);
            if (index === -1) {
                return Object.assign({}, state, {
                    conversationsList: [action.payload.conversation, ...state.conversationsList],
                });
            } else if (action.payload.conversation.status !== state.conversationsList[index].status) {
                state.conversationsList.splice(index, 1, action.payload.conversation);
                return Object.assign({}, state, {
                    conversationsList: state.conversationsList,
                });
            } else if (action.payload.conversation.operatorId !== state.conversationsList[index].operatorId) {
                state.conversationsList.splice(index, 1, action.payload.conversation);
                return Object.assign({}, state, {
                    conversationsList: state.conversationsList,
                });
            }
            return state;
        }

        case SELECT_CONVERSATION_REQUESTED:
            if (action.payload.conversation.id === state.conversation.id) {
                return state;
            }
            return Object.assign({}, state, {
                conversation: Object.assign({}, state.conversation, {
                    loading: true,
                }),
            });

        case SELECT_CONVERSATION_SUCCEEDED: {
            const {conversation, messages, messagesTotalNumber} = action.payload;
            return Object.assign({}, state, {
                conversation: Object.assign({}, state.conversation, {
                    ...conversation,
                    messages,
                    messagesTotalNumber,
                    loading: false,
                }),
            });
        }

        case SELECT_CONVERSATION_FAILED:
            return Object.assign({}, state, {
                conversation: Object.assign({}, state.conversation, {
                    loading: false,
                }),
            });

        case INSERT_CHAT_MESSAGE:
            return Object.assign({}, state, {
                conversation: Object.assign({}, state.conversation, {
                    messages: [action.payload.message, ...state.conversation.messages],
                    messagesTotalNumber: state.conversation.messagesTotalNumber + 1,
                }),
            });

        case DELETE_CHAT_MESSAGE:
            return {
                ...state,
                conversation: {
                    ...state.conversation,
                    messages: state.conversation.messages.filter(
                        (msg) => msg.id !== action.payload.message.id
                    ),
                    messagesTotalNumber: state.conversation.messagesTotalNumber - 1,
                },
            };

        case EDIT_CHAT_MESSAGE:
            return {
                ...state,
                conversation: {
                    ...state.conversation,
                    messages: state.conversation.messages.map((msg) =>
                        msg.id === action.payload.message.id
                            ? { ...msg, text: action.payload.message.text, edited: true }
                            : msg
                    ),
                    messagesTotalNumber: state.conversation.messagesTotalNumber,
                },
            };

        case HANDLE_NOT_SENT_MESSAGE:
            return {
                ...state,
                conversation: {
                    ...state.conversation,
                    messages: state.conversation.messages.map((msg) => {
                        if (msg.id === action.payload.message.id) {
                            return {
                                ...msg,
                                notSent: true
                            };
                        }
                        return msg;
                    }),
                },
            };

        case OPEN_FORWARD_DIALOG:
            return Object.assign({}, state, {
                forwardDialog: Object.assign({}, state.forwardDialog, {
                    isOpen: true,
                }),
            });

        case CLOSE_FORWARD_DIALOG:
            return Object.assign({}, state, {
                forwardDialog: Object.assign({}, state.forwardDialog, {
                    isOpen: false,
                }),
            });

        case FORWARD_CONVERSATION_REQUESTED:
            return Object.assign({}, state, {
                forwardDialog: Object.assign({}, state.forwardDialog, {
                    forwardInProgress: true,
                }),
            });

        case FORWARD_CONVERSATION_SUCCEEDED:
            return Object.assign({}, state, {
                forwardDialog: Object.assign({}, state.forwardDialog, {
                    forwardInProgress: false,
                    isOpen: false,
                }),
            });

        case FORWARD_CONVERSATION_FAILED:
            return Object.assign({}, state, {
                forwardDialog: Object.assign({}, state.forwardDialog, {
                    forwardInProgress: false,
                    isOpen: false,
                }),
            });
        case UPDATE_SELECTED_CONVERSATION:
            return Object.assign({}, state, {
                conversation: Object.assign({}, state.conversation, action.payload),
            });

        case LOAD_OLDER_MESSAGES_REQUESTED:
            return Object.assign({}, state, {
                conversation: Object.assign({}, state.conversation, {loadingOlderMessages: true}),
            });

        case LOAD_OLDER_MESSAGES_SUCCEEDED:
            return Object.assign({}, state, {
                conversation: Object.assign({}, state.conversation, {
                    messages: [...state.conversation.messages, ...action.payload.messages],
                    loadingOlderMessages: false,
                }),
            });

        case LOAD_OLDER_MESSAGES_FAILED:
            return Object.assign({}, state, {
                conversation: Object.assign({}, state.conversation, {loadingOlderMessages: false}),
            });

        case CLEAR_SELECTED_CONVERSATION:
            return Object.assign({}, state, {
                conversation: getConversationInitialState(),
            });
        case SET_MESSAGE_SEEN:
            return {
                ...state,
                lastSeenMessageId: action.payload.messageId,
            };
        case USER_TYPING_START: {
            const { conversationId } = action.payload;
            if (!state.activeTypingConvIds.includes(conversationId)) {
                return {
                    ...state,
                    activeTypingConvIds: [...state.activeTypingConvIds, conversationId],
                };
            }
            return state;
        }
        case USER_TYPING_STOP: {
            const { conversationId } = action.payload;
            return {
                ...state,
                activeTypingConvIds: state.activeTypingConvIds.filter(
                    id => id !== conversationId
                ),
            };
        }
        case DESTROY_CHAT:
            return initialState;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/services/chat/reducer.js